<template lang="html">
  <d-button class="btn btn-info ml-4 text-uppercase" @click="paidQuotation()">
    Marcar como pago <i class=" fas fa-dollar-sign"></i>
  </d-button>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import QuotationService from '_services/rest/modules/quotation';
import { _LOAD_MODEL_ } from '_modules/quotation/components/QuotationModel';

export default {
  name: 'quotation-button-approve-payment',
  data() {
    return {
      pagination: {
        search: '',
        userId: null,
        statusId: null,
        priorityId: null,
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  props: {
    quotation: {
      type: Object,
      default: null,
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getQuotationList',
    ]),
    close() {
      this.setToggle({ type: 'quotation-button-approve-payment', bool: false });
    },
    paidQuotation() {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.paidQuotation(this.quotation)
        .then(response => {
          this.setToggle({ type: 'quotation-button-approve-payment', bool: false });
          Events.$emit(_LOAD_MODEL_, response);
          this.getQuotationList(this.pagination)
            .then(() => {
              this.setToggle({ type: 'progress', bool: false });
            });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
};
</script>
